import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import AccountantInvoice from '../../../components/invoice'
import './style.scss'
const AccountantInvoicePage = () => {

    return (
        <Fragment>
            
           <AccountantInvoice
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default AccountantInvoicePage
/* InvoicePreviewArea */